import api from './api'

export default {
  findAddressByZipcode(zipcode) {
    return api.get(`/addresses/address-by-zipcode/${zipcode}`)
  },
}
